[
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "a998e96e-dbaa-4660-9a8d-22e4a5f36afc",
        "callUuid": "8de66fb2-a0ec-485b-b640-1d6cf9727b29",
        "callName": "Addressing Doctor Skepticism on Safety Profile"
    }
]

